export default {
  number: 1.1,
}
